import { uniqueId } from '@highlight-ui/utils-commons';
import { useMemo } from 'react';

export const useId = (prefix?: string) => {
  return useMemo(() => uniqueId(prefix), [prefix]);
};
export default useId;
